import useCustomModal, {UseCustomModalProps} from "./useCustomModal";
import {IPopulatedJob} from "../../types/FrontendTypes.ts";
import {Box, Typography} from "@mui/material";
import JobRest from "../../rest/JobRest.ts";
import React from "react";
import ImageRest from "../../rest/ImageRest.ts";
import {ModalJobCard} from "./ModalCards/ModalJobCard.tsx";
import {ModalCutterCard} from "./ModalCards/ModalCutterCard.tsx";
import {Dangerous, Delete, DeleteForever} from "@mui/icons-material";

export interface DeleteJobModalProps {
    job?: IPopulatedJob;
    jobRest: JobRest;
    imageRest: ImageRest;
    afterDelete?: () => void;
}

export const useDeleteJobModal = (props: DeleteJobModalProps) => {
    const {job, jobRest, imageRest, afterDelete} = props;
    let modalOptions: UseCustomModalProps;

    if (job && job.cutter && job.cutter.state.jobId === job._id) {
        const content =
            <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                <Typography>The job you are trying to delete</Typography>
                <ModalJobCard job={job} imageRest={imageRest}/>
                <Typography>is currently being executed on this cutter:</Typography>
                <ModalCutterCard cutter={job.cutter} imageRest={imageRest}/>
                <Typography>Do you want to abort the job execution?</Typography>
            </Box>

        modalOptions = {
            title: "Abort running job?",
            customContent: content,
            defaultAction: {
                label: "Delete & Abort",
                method: () => jobRest.delete(job._id, true).then(afterDelete),
                icon: <Dangerous/>,
                color: "error"
            },
            secondaryAction: {
                label: "Delete & Keep running",
                method: () => jobRest.delete(job._id, false).then(afterDelete),
                icon: <Delete/>,
                color: "error"
            },
            cancelAction: {
                label: "Cancel",
                props: {sx: {mr: 2}}
            },
        };
    } else if (job) {
        const content =
            <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                <Typography>Are you sure, that you want to delete this job?</Typography>
                <ModalJobCard job={job} imageRest={imageRest}/>
            </Box>

        modalOptions = {
            title: "Confirm job deletion",
            customContent: content,
            defaultAction: {
                label: "Delete",
                method: () => jobRest.delete(job._id).then(afterDelete),
                icon: <DeleteForever/>,
                color: "error"
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    } else {
        modalOptions = {
            title: "Error",
            contentText: "The job data is not available. Please try again later.",
            defaultAction: {
                label: "Close",
                method: () => {
                },
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    }

    const {open} = useCustomModal(modalOptions);

    return open;
};

export default useDeleteJobModal;